type SortableNetwork = {
  dc_id?: string | null;
  network_name: string;
};

// LEAD, MSSP, ACO REACH, other prefixes, then missing IDs.
const dcIdPrefixOrder: Record<string, number> = { L: 0, A: 1, D: 2 };

const getDcIdSortRank = (dcId: string): number =>
  dcId ? dcIdPrefixOrder[dcId.charAt(0)] ?? 3 : 4;

export const compareClientNetworks = (
  a: SortableNetwork,
  b: SortableNetwork
): number => {
  const aDcId = a.dc_id || '';
  const bDcId = b.dc_id || '';

  return (
    getDcIdSortRank(aDcId) - getDcIdSortRank(bDcId) ||
    aDcId.localeCompare(bDcId) ||
    a.network_name.localeCompare(b.network_name)
  );
};
